import { RUI_TOAST_DISMISS_EVENT, RUI_TOAST_SHOW_EVENT } from "./toast-context";
import { toastState } from "./toast-state";
export const toast = Object.assign((title, options) => toastState.create(title, options), {
  message: (title, options) => toastState.message(title, options),
  success: (title, options) => toastState.success(title, options),
  error: (title, options) => toastState.error(title, options),
  info: (title, options) => toastState.info(title, options),
  warning: (title, options) => toastState.warning(title, options),
  loading: (title, options) => toastState.loading(title, options),
  promise: (promise, messages) => toastState.promise(promise, messages),
  dismiss: id => toastState.dismiss(id),
  clear: () => toastState.clear()
});
export function showToast(detail) {
  document.dispatchEvent(new CustomEvent(RUI_TOAST_SHOW_EVENT, {
    detail,
    bubbles: true,
    composed: true
  }));
}
export function dismissToast(id) {
  const detail = id == null ? {} : {
    id
  };
  document.dispatchEvent(new CustomEvent(RUI_TOAST_DISMISS_EVENT, {
    detail,
    bubbles: true,
    composed: true
  }));
}